<template>
  <nav
    class="sticky top-0 z-50 bg-white"
    style="box-shadow: 0 10px 30px 0 rgba(20, 184, 166, 0.08)"
  >
    <DesktopNav :nav-data="navData" @open-drawer="drawerOpen = true" />

    <MobileNav
      :nav-data="navData"
      :menu-open="mobileMenuOpen"
      @open-drawer="drawerOpen = true"
      @toggle-menu="mobileMenuOpen = !mobileMenuOpen"
    />

    <NavigationDrawer
      :open="drawerOpen"
      :nav-data="navData"
      :csrf-token="csrfToken"
      @close="drawerOpen = false"
    />
  </nav>
</template>

<script setup>
import { ref, computed } from "vue";
import { usePage } from "@inertiajs/vue3";
import DesktopNav from "./DesktopNav.vue";
import MobileNav from "./MobileNav.vue";
import NavigationDrawer from "./NavigationDrawer.vue";

const page = usePage();
const navData = computed(() => page.props.navData);
const csrfToken = computed(() => page.props.navData?.csrfToken);

const drawerOpen = ref(false);
const mobileMenuOpen = ref(false);
</script>
